import React, { useState } from "react";
import "./portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

// TopupWeb
import Topup from "../../assets/portfolio-carousel/TopupWeb/Topup1.png";
import Topup1 from "../../assets/portfolio-carousel/TopupWeb/Topup2.png";
import Topup2 from "../../assets/portfolio-carousel/TopupWeb/Topup3.png";
import Topup3 from "../../assets/portfolio-carousel/TopupWeb/Topup4.png";
import Topup4 from "../../assets/portfolio-carousel/TopupWeb/Topup5.png";
import Topup5 from "../../assets/portfolio-carousel/TopupWeb/Topup6.png";
import Topup6 from "../../assets/portfolio-carousel/TopupWeb/Topup7.png";
import Topup7 from "../../assets/portfolio-carousel/TopupWeb/Topup8.png";
import Topup8 from "../../assets/portfolio-carousel/TopupWeb/Topup9.png";
import Topup9 from "../../assets/portfolio-carousel/TopupWeb/Topup10.png";
import Topup10 from "../../assets/portfolio-carousel/TopupWeb/Topup11.png";
import Topup11 from "../../assets/portfolio-carousel/TopupWeb/Topup12.png";
import Topup12 from "../../assets/portfolio-carousel/TopupWeb/Topup13.png";
import Topup13 from "../../assets/portfolio-carousel/TopupWeb/Topup14.png";
import Topup14 from "../../assets/portfolio-carousel/TopupWeb/Topup15.png";
import Topup15 from "../../assets/portfolio-carousel/TopupWeb/Topup16.png";

// Point of Sales
import Pos from "../../assets/portfolio-carousel/POS/Pos1.png";
import Pos1 from "../../assets/portfolio-carousel/POS/Pos2.png";

// MovieIn
import movieinImg from "../../assets/portfolio-carousel/Moviein-web/moviein1.png";
import movieinImg1 from "../../assets/portfolio-carousel/Moviein-web/moviein2.png";
import movieinImg2 from "../../assets/portfolio-carousel/Moviein-web/moviein3.png";
import movieinImg3 from "../../assets/portfolio-carousel/Moviein-web/moviein4.png";
import movieinImg4 from "../../assets/portfolio-carousel/Moviein-web/moviein5.png";

// WeddingIn
import weddingIn from "../../assets/portfolio-carousel/WeddingIn/weddingin-landing.png";
import weddingIn1 from "../../assets/portfolio-carousel/WeddingIn/weddingin-about.png";
import weddingIn2 from "../../assets/portfolio-carousel/WeddingIn/weddingin-testimoni.png";
import weddingIn3 from "../../assets/portfolio-carousel/WeddingIn/weddingin-contact.png";
import weddingIn4 from "../../assets/portfolio-carousel/WeddingIn/weddingin-package.png";
import weddingIn5 from "../../assets/portfolio-carousel/WeddingIn/weddingin-article.png";
import weddingIn6 from "../../assets/portfolio-carousel/WeddingIn/weddingin-login.png";
import weddingIn7 from "../../assets/portfolio-carousel/WeddingIn/weddingin-dashboard.png";
import weddingIn8 from "../../assets/portfolio-carousel/WeddingIn/weddingin-settings.png";
import weddingIn9 from "../../assets/portfolio-carousel/WeddingIn/weddingin-catalogue.png";
import weddingIn10 from "../../assets/portfolio-carousel/WeddingIn/weddingin-order.png";
import weddingIn11 from "../../assets/portfolio-carousel/WeddingIn/weddingin-report.png";

// BandungIn
import bandungIn from "../../assets/portfolio-carousel/BandungIn/bandungIn1.png";
import bandungIn1 from "../../assets/portfolio-carousel/BandungIn/bandungIn2.png";
import bandungIn2 from "../../assets/portfolio-carousel/BandungIn/bandungIn3.png";
import bandungIn3 from "../../assets/portfolio-carousel/BandungIn/bandungIn4.png";
import bandungIn4 from "../../assets/portfolio-carousel/BandungIn/bandungIn5.png";
import bandungIn5 from "../../assets/portfolio-carousel/BandungIn/bandungIn6.png";
import bandungIn6 from "../../assets/portfolio-carousel/BandungIn/bandungIn7.png";
import bandungIn7 from "../../assets/portfolio-carousel/BandungIn/bandungIn8.png";
import bandungIn8 from "../../assets/portfolio-carousel/BandungIn/bandungIn9.png";
import bandungIn9 from "../../assets/portfolio-carousel/BandungIn/bandungIn10.png";
import bandungIn10 from "../../assets/portfolio-carousel/BandungIn/bandungIn11.png";
import bandungIn11 from "../../assets/portfolio-carousel/BandungIn/bandungIn12.png";
import bandungIn12 from "../../assets/portfolio-carousel/BandungIn/bandungIn13.png";

// Portofolio V1
import Porto from "../../assets/portfolio-carousel/Porto-v1/porto1.png";
import Porto1 from "../../assets/portfolio-carousel/Porto-v1/porto2.png";
import Porto2 from "../../assets/portfolio-carousel/Porto-v1/porto3.png";
import Porto3 from "../../assets/portfolio-carousel/Porto-v1/porto4.png";
import Porto4 from "../../assets/portfolio-carousel/Porto-v1/porto5.png";

// Agency-web
import Agency from "../../assets/portfolio-carousel/Agency-web/agency-web1.webp";
import Agency1 from "../../assets/portfolio-carousel/Agency-web/agency-web2.webp";
import Agency2 from "../../assets/portfolio-carousel/Agency-web/agency-web3.webp";
import Agency3 from "../../assets/portfolio-carousel/Agency-web/agency-web4.webp";
import Agency4 from "../../assets/portfolio-carousel/Agency-web/agency-web5.webp";
import Agency5 from "../../assets/portfolio-carousel/Agency-web/agency-web6.webp";

// Genius Galaxy
import Games from "../../assets/portfolio-carousel/Genius-Galaxy/icon_genius_galaxy.png";
import Games1 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game1.png";
import Games2 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game2.png";
import Games3 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game3.png";
import Games4 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game4.png";
import Games5 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game5.png";
import Games6 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game6.png";
import Games7 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game7.png";
import Games8 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game8.png";
import Games9 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game9.png";
import Games10 from "../../assets/portfolio-carousel/Genius-Galaxy/ss-game10.png";

// Login Form
import Login from "../../assets/portfolio-carousel/Login-form/login1.png";
import Login1 from "../../assets/portfolio-carousel/Login-form/login2.png";
import Login2 from "../../assets/portfolio-carousel/Login-form/login3.png";
import Login3 from "../../assets/portfolio-carousel/Login-form/login4.png";
import Login4 from "../../assets/portfolio-carousel/Login-form/login.gif";

// Dom
import Dom from "../../assets/portfolio-carousel/Dom/dom-1.png";
import Dom1 from "../../assets/portfolio-carousel/Dom/dom-2.png";
import Dom2 from "../../assets/portfolio-carousel/Dom/dom-3.png";

// Animation
import Animation from "../../assets/portfolio-carousel/Animation/animation2.webp";
import Animation1 from "../../assets/portfolio-carousel/Animation/animation3.webp";
import Animation2 from "../../assets/portfolio-carousel/Animation/animation4.webp";
import Animation3 from "../../assets/portfolio-carousel/Animation/animation5.webp";
import Animation4 from "../../assets/portfolio-carousel/Animation/animation6.webp";
import Animation5 from "../../assets/portfolio-carousel/Animation/animation7.webp";
import Animation6 from "../../assets/portfolio-carousel/Animation/animation8.webp";
import Animation7 from "../../assets/portfolio-carousel/Animation/animation9.webp";


const Portfolio = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const projects = [
    // Topup Web
    {
      images: [Topup, Topup1, Topup2, Topup3, Topup4, Topup5, Topup6, Topup7, Topup8, Topup9, Topup10, Topup11, Topup12, Topup13, Topup14, Topup15],
      title: "Web Topup Games",
      description: "This B2C website is designed to provide a fast and easy online shopping experience for customers who want to buy diamonds and game vouchers. The platform focuses on ease of use, modern interface, and responsiveness, so that it can be accessed comfortably on various devices. In this project, I was fully responsible for the development of the entire website interface using React, Vite, Tailwind CSS, and TypeScript.",
      link: "https://entertopup.com/",
      info: [
        "Using React, Vite, Tailwind CSS, and TypeScript",
        "Create an attractive main page, displaying diamond products and game vouchers with a user-friendly layout",
        "Build category, product detail, and checkout pages that are easy for users to navigate",
        "Optimize website display so that it looks perfect on various devices, from desktops to smartphones",
        "Develop reusable UI components such as buttons, product cards, search forms, and navigation elements to facilitate maintenance and further development",
        "Provide interface documentation to make it easier for backend teams or other developers to integrate features and data",
      ],
    },

    // POS
    {
      images: [Pos, Pos1],
      title: "Point of Sales",
      description: "Point of Sales (POS) is a web-based application designed to facilitate the sales process, inventory management, and transaction reporting. In this project, I was solely responsible for the development of all interface components using React, Vite, Tailwind CSS, and TypeScript. Although I did not implement the business logic or enable the components, I ensured that each component I developed was optimally designed to support the required functionality.",
      // link: "",
      info: [
        "Using React, Vite, Tailwind CSS, and TypeScript",
        "Build responsive user interface components, including buttons, tables, forms, and navigation elements",
        "Use Tailwind CSS to create modern, clean, and responsive designs",
        "Write code with TypeScript to increase reliability and ease collaboration between teams",
      ],
    },

    // Platform Streaming
    {
      images: [movieinImg, movieinImg1, movieinImg2, movieinImg3, movieinImg4],
      title: "Platform Streaming",
      description: "MovieIn website is a platform designed to provide users with up-to-date information about movies. The main goal of the project is to provide a satisfying experience for movie fans by providing accurate, complete, and detailed information about different types of movies, ranging from Hollywood blockbusters to independent films.",
      link: "https://moviein.vercel.app",
      info: [
        "Using Javascript and API from TMDB",
        "The Most Complete Movie Database",
        "Comprehensive Movie Description",
        "Recommendation Feature",
        "User-Friendly User Interface",
        "Responsive User Interface",
      ],
    },

    // Wedding Organizer
    {
      images: [weddingIn, weddingIn1, weddingIn2, weddingIn3, weddingIn4, weddingIn5, 
                weddingIn6, weddingIn7, weddingIn8, weddingIn9, weddingIn10, weddingIn11],
      title: "Wedding Organizer",
      description: "WeddinWeddingIn is a wedding organizer platform that offers complete services to make dream weddings a reality. With features such as a flexible package catalog, informative article pages, responsive contact form and admin panel, WeddingIn makes it easy to plan weddings according to user needs.",
      // link: "https://weddingin.example.com",
      info: [
        "Frontend: HTML, CSS, JavaScript",
        "Backend: PHP, MySQL",
        "User-Friendly User Interface",
        "Responsive User Interface",
        "Login feature that makes it easy for users to manage bookings and catalogs",
        "Full support via contact page to ensure every user gets the help they need",
      ],
    },

    // Tourism Website
    {
      images: [bandungIn, bandungIn1, bandungIn2, bandungIn3, bandungIn4, bandungIn5, 
                bandungIn6, bandungIn7, bandungIn8, bandungIn9, bandungIn10, bandungIn11, bandungIn12],
      title: "Tourism Website",
      description: "BandungIn is our ambitious project that aims to be the center of up-to-date tourism information in Bandung City. With an attractive and functional design, this website allows users to explore and gain in-depth insights into interesting tourist attractions around Bandung. In the project, I was in charge of creating contact us, login form, article display, and responsive website.",
      // link: "https://bandungin.example.com",
      info: [
        "Using React, Javascript and PHP",
        "User-Friendly user interface",
        "Responsive user interface",
        "Interactive user interface",
        "Easy navigation for tourists",
        "Functionality to review, edit or delete testimonials",
        "Security settings to prevent unwanted reviews",
      ],
    },

    // Portfolio V1
    {
      images: [Porto, Porto1, Porto2, Porto3, Porto4],
      title: "Portfolio V1",
      description: "Portfolio V1 is a personalized project designed to showcase profiles, skills, experience, and best work in the form of a static website. The project was developed using HTML, CSS, and JavaScript, focusing on a simple yet professional presentation.",
      link: "https://nxndi-v1.vercel.app",
      info: [
        "Using HTML, CSS and JavaScript",
        "The fully responsive design ensures optimal viewing across a wide range of devices, from mobile phones to desktop screens.",
        "Intuitive navigation menu makes it easy for users to explore different parts of the portfolio",
        "Using JavaScript to add scroll effects, animations, and interactive transitions for a more engaging user experience",
        "Code is written to a good standard for ease of management and further development",
      ],
    },

    // Agency Website
    {
      images: [Agency, Agency1, Agency2, Agency3, Agency4, Agency5],
      title: "Blogger Website",
      description: "BukaBlog is an innovative platform specifically designed to provide information and learning about the world of informatics. BukaBlog is a digital space dedicated to technology lovers, software developers, and anyone who wants to explore the world of informatics. This project not only focuses on practical aspects, but is also supported by high-quality content that is presented in an attractive and easy-to-understand manner.",
      link: "https://nandirifaldi.blogspot.com/",
      info: [
        "Using Blogger",
        "User-Friendly user interface",
        "Responsive user interface",
        "High Quality Articles",
      ],
    },

    // Educational Games
    {
      images: [Games, Games1, Games2, Games3, Games4, Games5, Games6, Games7, Games8, Games9, Games10],
      title: "Educational Games",
      description: "Genius Galaxy is an educational game project designed specifically for elementary school students. The game aims to combine educational elements with entertainment, creating a fun and interactive learning experience.",
      link: "https://play.google.com/store/apps/details?id=com.nxndi.GeniusGalaxy",
      info: [
        "Using C# and Unity3D",
        "Interactive and Educational : Each challenge in the game is designed to teach important concepts in a fun and easy-to-understand way.",
        "Attractive Graphics : Bright and colorful visuals grab children's attention and make them feel at home playing while learning.",
        "Tiered Levels : Players can unlock new levels and earn achievements as they complete challenges, providing a sense of accomplishment and encouragement to keep playing.",
      ],
    },

    // Login Form
    {
      images: [Login, Login1, Login2, Login3, Login4],
      title: "Login Form",
      description: "A login form project developed with a focus on security and ease of use. Designed to provide users with a secure and efficient login experience, the project utilized the latest technology to ensure optimal data protection.",
      // link: "",
      info: [
        "Using HTML, CSS, and JavaScript",
        "User-Friendly user interface",
        "Responsive user interface",
        "Implementation of input validation to ensure that users provide correct and appropriate information",
        "Informative error message handling when users enter invalid information",
        "Clear display style to provide visual feedback to users",
      ],
    },

    // Login Form
    {
      images: [Dom, Dom1, Dom2],
      title: "Login Form",
      description: "This project aims to create an interactive login form using DOM (Document Object Model). The DOM is a structural representation of an HTML document that allows manipulation and interaction with elements on a web page. By utilizing the DOM, this project will create a responsive and user-friendly login experience.",
      // link: "",
      info: [
        "Using HTML, CSS, and JavaScript",
        "Creation of a login form with input elements for username, email, and password",
        "Clean and user-friendly design to enhance user experience",
        "Implementation of input validation to ensure that users provide correct and appropriate information",
        "Informative error message handling when users enter invalid information",
        "Clear display style to provide visual feedback to users",
      ],
    },

    // Animation
    {
      images: [Animation, Animation1, Animation2, Animation3, Animation4, Animation5, Animation6, Animation7],
      title: "Animation",
      description: "The Slice of Life animation project is a creation using the FlipaClip application, which raises the theme of everyday life with a unique and entertaining visual touch. Using FlipaClip's simple yet powerful tools, this project tells small stories from everyday life with color and creativity.",
      link: "https://drive.google.com/file/d/1nxWvmuAh_bCEDcmIEboN6VhmhqtOUpBD/view?usp=sharing",
      info: [
        "Animation Speed : Development of an animation with 8 fps",
        "Charming Character Design : Development of unique characters that enhance the story and appeal of the animation",
        "Authentic Slice of Life Plot : Realistic and relatable depiction of daily life, adding elements of humor and warmth",
        "Frame by Frame Animation : Use of frame by frame animation technique with FlipaClip to give a soft and natural touch to the character's movement",
        "Sketches and Colors : Selection of bright and energetic colors to provide a positive and fun atmosphere",
        "Use of Music and Sound : Integration of music or sound effects to enhance the audience experience and provide a feel that matches the theme of the animation",
        "Progressive Storytelling : Progressive story development through each animated scene, providing visual and narrative satisfaction",
        "Detailed Expression and Movement : Emphasis on character expressions and detailed movements to better express emotions and daily life"
      ],
    },
  ];

  return (
    <section className="portfolio section" id="portfolio">
      <h2 className="section__title" data-aos="fade-right">Portfolios</h2>
      <span className="section__subtitle" data-aos="fade-right" data-aos-delay="200">Most recent work</span>

      <div className="portfolio__container container grid">
        {projects.map((project, index) => (
          <div className="portfolio__card" key={index}>
            <img
              src={project.images[0]}
              alt={project.title}
              className="portfolio__image"
            />
            <h3 className="portfolio__title">{project.title}</h3>
            <span
              className="portfolio__button"
              onClick={() => toggleTab(index + 1)}
            >
              View More{" "}
              <i className="uil uil-arrow-right portfolio__button-icon"></i>
            </span>

            {/* MODAL */}
            <div
              className={
                toggleState === index + 1
                  ? "portfolio__modal active-modal"
                  : "portfolio__modal"
              }
            >
              <div className="portfolio__modal-content">
                <i
                  onClick={() => toggleTab(0)}
                  className="uil uil-times portfolio__modal-close"
                ></i>
                <h3 className="portfolio__modal-title">{project.title}</h3>

                {/* Swiper Carousel */}
                <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    spaceBetween={24}
                    loop={false}
                    grabCursor={true}
                    autoplay={{
                      delay: 3000, // Durasi dalam milidetik
                      disableOnInteraction: false,
                    }}
                    className="portfolio__modal-swiper"
                  >
                  {project.images.map((image, i) => (
                    <SwiperSlide key={i}>
                      <img
                        src={image}
                        alt={`${project.title} Slide ${i + 1}`}
                        className="portfolio__modal-image"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Deskripsi */}
                <p className="portfolio__modal-description">
                  {project.description}
                </p>

                {/* Link to Project */}
                <a 
                  href={project.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="portfolio__modal-link"
                >
                  Visit {project.title}
                </a>

                {/* Modal Info */}
                <ul className="services__modal-services grid">
                  {project.info.map((item, i) => (
                    <li className="services__modal-service" key={i}>
                      <i className="uil uil-check-circle services__modal-icon"></i>
                      <p className="services__modal-info">{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
